function mergeDescribedBy(...references: Array<string | false | undefined>) {
  const ids = new Set(
    references.flatMap((reference) =>
      reference ? reference.split(" ").filter(Boolean) : []
    )
  );

  return ids.size > 0 ? [...ids].join(" ") : undefined;
}

export { mergeDescribedBy };
